import { Chip } from '@mui/material';
import dayjs from 'dayjs';

export const taskApprovalColumns = [
  {
    field: 'task_approval_id',
    headerName: 'ID',
    width: 80,
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1.5,
    minWidth: 250,
  },
  {
    field: 'created_by_name',
    headerName: 'Created By',
    width: 180,
  },
  {
    field: 'priority',
    headerName: 'Priority',
    width: 130,
    renderCell: (params) => {
      const value = params.value;

      const config = {
        1: { label: 'Low', color: 'success' },
        2: { label: 'Medium', color: 'warning' },
        3: { label: 'High', color: 'error' },
        4: { label: 'Critical', color: 'error' },
      };

      const { label, color } = config[value] || {
        label: value,
        color: 'default',
      };

      return <Chip label={label} color={color} size="small" variant={value === 4 ? 'filled' : 'outlined'} />;
    },
  },
  {
    field: 'task_approval_status',
    headerName: 'Approval Status',
    width: 160,
    renderCell: (params) => {
      const value = params.value;

      const config = {
        0: { label: 'Pending', color: 'warning' },
        1: { label: 'Approved', color: 'success' },
        2: { label: 'Rejected', color: 'error' }, // optional
      };

      const { label, color } = config[value] || {
        label: value,
        color: 'default',
      };

      return <Chip label={label} color={color} size="small" />;
    },
  },
  {
    field: 'current_status',
    headerName: 'Task Status',
    width: 150,
    renderCell: (params) => {
      const value = params.value;

      const config = {
        0: { label: 'Open', color: 'default' },
        1: { label: 'In Progress', color: 'info' },
        2: { label: 'Completed', color: 'success' },
      };

      const { label, color } = config[value] || {
        label: value,
        color: 'default',
      };

      return <Chip label={label} color={color} size="small" />;
    },
  },
  {
    field: 'expected_delivery_date',
    headerName: 'Expected Date',
    width: 180,
    valueFormatter: ({ value }) => (value ? dayjs(value).format('DD-MM-YYYY HH:mm') : '-'),
  },
  {
    field: 'actual_delivery_date',
    headerName: 'Actual Date',
    width: 180,
    valueFormatter: ({ value }) => (value ? dayjs(value).format('DD-MM-YYYY HH:mm') : '-'),
  },
  {
    field: 'task_approved_at',
    headerName: 'Approved At',
    width: 180,
    valueFormatter: ({ value }) => (value ? dayjs(value).format('DD-MM-YYYY HH:mm') : '-'),
  },
  {
    field: 'created_at',
    headerName: 'Created At',
    width: 180,
    valueFormatter: ({ value }) => dayjs(value).format('DD-MM-YYYY HH:mm'),
  },
];
